<template>
  <v-modal :modal-id="'regionSelectorWebshop'"
           :modal-class="'region-selector'"
           :title-id="'regionTitleWebshop'"
           @close="close()">
    <h2 id="regionTitleWebshop">{{ $t('regionSelect.modalTitle') }}</h2>
    <region-selector @regionSelectionDraftChanged="onDraftChange" @regionSelectionChanged="close()"/>
  </v-modal>
</template>

<script>
import VModal from './Modal'
import RegionSelector from '../RegionSelector'

export default {
  components: {
    VModal,
    RegionSelector
  },
  methods: {
    close: function () {
      this.$emit('regionSelectionChanged')
      this.$emit('close')
    },
    onDraftChange: function (draft) {
      this.$emit('regionSelectionDraftChanged', draft)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/RegionSelectorWebshop.vue